import React from 'react';

import { Table, TableBody, TableContainer } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import { StyledLabel } from '../forms/styles';
import { ClassSession } from './types';
import SessionRow from './SessionRow';

const SelectedDates = styled(TableContainer)`
    max-height: 250px;
    border-radius: 5px;
`;

export interface SessionsTableProps {
    sessions: ClassSession[];
    excludeSession?: (session: ClassSession) => void;
}

export const SessionsTable = (props: SessionsTableProps) => {
    const { sessions, excludeSession } = props;
    const { t } = useTranslation('calendar');

    if (sessions.length < 1) return null;

    return (
        <>
            <StyledLabel>{t('selected-dates')}</StyledLabel>
            <SelectedDates>
                <Table stickyHeader size="small">
                    <TableBody>
                        {sessions.map((session) => (
                            <SessionRow
                                key={`${session.start_time}:${session.end_time}`}
                                session={session}
                                sessionsLength={sessions.length}
                                excludeSession={excludeSession}
                            />
                        ))}
                    </TableBody>
                </Table>
            </SelectedDates>
        </>
    );
};
